import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import { commonPostPutApi } from "../../../redux/reducers/commonApiSlice";
import CommonHeadingNBtns from "../../common-components/CommonHeadingNBtns";

const BulkSubCategoryForm = ({
  token,
  onCloseModal,
  selectedCategory,
  refetchData,
}) => {
  const dispatch = useDispatch();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [subCategories, setSubCategories] = useState([{ name: "" }]);

  const addSubCategory = () => {
    setSubCategories([...subCategories, { name: "" }]);
  };

  const removeSubCategory = (index) => {
    if (subCategories.length > 1) {
      setSubCategories(subCategories.filter((_, i) => i !== index));
    }
  };

  const updateSubCategory = (index, value) => {
    const updated = [...subCategories];
    updated[index].name = value;
    setSubCategories(updated);
  };

  const handleSubmit = async () => {
    if (!selectedCategory?.uid) {
      toast.error("Please select a category first");
      return;
    }

    const validSubCategories = subCategories.filter(
      (sub) => sub.name.trim() !== ""
    );

    if (validSubCategories.length === 0) {
      toast.error("Please enter at least one sub category name");
      return;
    }

    setIsSubmitting(true);

    try {
      const payload = {
        subCategories: validSubCategories.map((sub) => ({
          name: sub.name.trim(),
          category_id: selectedCategory.uid,
        })),
      };

      const result = await dispatch(
        commonPostPutApi({
          endpoint: "/ticketSystem/sub-category/add-multiple",
          token: token,
          method: "POST",
          payload: payload,
        })
      );

      if (result?.payload?.status) {
        toast.success(
          result?.payload?.message || "Sub categories added successfully!"
        );
        refetchData();
        onCloseModal();
      } else {
        toast.error(result?.payload?.message || "Failed to add sub categories");
      }
    } catch (error) {
      toast.error("An error occurred. Please try again.");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="createNewCTOModalContainer mod-width-50p">
      <CommonHeadingNBtns
        title="Bulk Add Sub Categories"
        onClick={handleSubmit}
        isLoading={isSubmitting}
        btnTxt="Add Sub Categories"
        onClose={onCloseModal}
      />

      <form className="formContainer">
        <div className="formInputsGrid twoGridSystem">
          {selectedCategory && (
            <div className="formInputBox">
              <label className="formInputLabel">Category</label>
              <div className="commonWrapper">
                <div className="selected-item-display">
                  {selectedCategory.name}
                </div>
              </div>
            </div>
          )}

          <div className="formInputBox">
            <label className="formInputLabel">
              Sub Categories <span className="required">*</span>
            </label>
            <div className="bulk-input-container" style={{ width: "100%" }}>
              {subCategories.map((subCat, index) => (
                <div key={index} className="bulk-input-row">
                  <div className="commonWrapper">
                    <input
                      type="text"
                      className="formInput"
                      placeholder={`Sub category ${index + 1}`}
                      value={subCat.name}
                      onChange={(e) => updateSubCategory(index, e.target.value)}
                    />
                  </div>
                  {subCategories.length > 1 && (
                    <button
                      type="button"
                      className="remove-btn"
                      onClick={() => removeSubCategory(index)}
                    >
                      ×
                    </button>
                  )}
                </div>
              ))}
              <button
                type="button"
                className="add-more-btn"
                onClick={addSubCategory}
              >
                + Add More
              </button>
            </div>
          </div>
        </div>
      </form>
    </div>
  );
};

export default BulkSubCategoryForm;
